import React from "react";
import "../style/index.css";
import "@fontsource/rubik";

export const ProcessingError = () => (
  <div className="payment-card-invalid-creds">
    <div className="bg-red-100 p-4 rounded-lg shadow-md">
      <h1 className="text-xl font-bold">Transaction processing error</h1>
      <div className="flex justify-center mt-4 mb-2 text-red-400">
        <svg
          width="80"
          height="80"
          viewBox="0 0 40 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="20" cy="20" r="15.5" stroke="currentColor" />
          <path
            d="M24.7505 26.397L19.8008 21.4473L14.851 26.397L13.2011 24.7471L18.1509 19.7973L13.2011 14.8476L14.851 13.1977L19.8008 18.1474L24.7505 13.1977L26.4004 14.8476L21.4507 19.7973L26.4004 24.7471L24.7505 26.397Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <div className="text-sm">
        If the problem continues, please reach out to support after trying
        again.
      </div>
    </div>
  </div>
);
